// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2XFOS","question":"Question_question__22f-l","description":"Question_description__LDhga"};